import React, { useState, useEffect } from "react";
import ProfileDetails from "./ProfileDetails/ProfileDetails";
import AddressDetails from "./ProfileDetails/AddressDetails";
import SocialMedia from "./ProfileDetails/SocialMedia";
import Documentation from "./ProfileDetails/Documentation";
import useProfileStore from "../../store/builders/useProfileStore";

const ProfileBanner = ({ coverImageUrl, name, role, location, progress }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const { profile, fetchProfile, isLoading } = useProfileStore();

  useEffect(() => {
    // Fetch profile data on component mount
    const loadProfile = async () => {
      await fetchProfile();
    };
    loadProfile();
  }, [fetchProfile]); // Remove fetchProfile from deps array since it's stable

  return (
    <>
      <div className="bg-gray-100 overflow-hidden shadow rounded-2xl text-sm  ">
        {/* Cover Section */}
        

        {/* Profile Details Section */}
        <div className="relative px-5 py-2 bg-white">
          {/* Profile Image */}
          <div className="absolute -top-5 left-2">
            {isLoading ? (
              <div className="w-20 h-20 rounded-full border-2 border-white shadow-lg flex items-center justify-center bg-gray-200">
                <div className="w-6 h-6 border-2 border-blue-500 border-solid border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              <div className="relative">
                <img
                  src={profile?.profile_image || "/default-profile.png"} 
                  alt={profile?.name || "Profile"}
                  style={{ marginTop: "26px" }}
                  className="w-20 h-20 rounded-full border-2 border-white shadow-lg object-cover"
                />
                <div 
                  className="absolute bottom-12 -right-2  bg-white rounded-full p-1 shadow-lg cursor-pointer"
                  onClick={() => document.getElementById('profile-image-input').click()}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-4 w-4 text-gray-600" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" 
                    />
                  </svg>
                </div>
                <input
                  type="file"
                  id="profile-image-input"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      // Handle file upload here
                      const file = e.target.files[0];
                      // You'll need to implement the upload and save functionality
                      // Example: updateProfileImage(file)
                    }
                  }}
                />
              </div>
            )}
          </div>

          {/* User Info */}
          <div className="ml-24 pt-0">
            <h2 className="text-base font-semibold">{profile?.name || name}</h2>
            <p className="text-gray-600 flex items-center space-x-2 text-sm">
              <span>{profile?.role || role}</span>
              <span>•</span>
              <span>{profile?.location || location}</span>
            </p>

            {/* Progress Bar */}
            <div className="mt-2">
              <div className="h-1.5 bg-gray-200 rounded-full w-32">
                <div
                  className="h-full bg-blue-500 rounded-full"
                  style={{ width: `${profile?.profile_completion || progress}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mt-1">{profile?.profile_completion || progress}%</p>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="relative bg-white pt-2">
          <ul className="flex justify-start gap-6 text-gray-600 w-full px-4 text-sm">
            <li
              className={`cursor-pointer px-4 py-2 h-full ${
                activeTab === "profile" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
              }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("profile")}
            >
              Profile
            </li>
            <li
              className={`cursor-pointer px-4 py-2 h-full ${
                activeTab === "address" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
              }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("address")}
            >
              Address
            </li>
            <li
              className={`cursor-pointer px-4 py-2 h-full ${
                activeTab === "documentation" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
              }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("documentation")}
            >
              Documentation
            </li>
            <li
              className={`cursor-pointer px-4 py-2 h-full ${
                activeTab === "social" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
              }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("social")}
            >
              Social Media
            </li>
          </ul>
        </div>
      </div>

      {/* Dynamic Section - Placed Outside with Gap */}
      <div className="mt-4 p-4 bg-white shadow-md rounded-2xl text-sm">
        {activeTab === "profile" && <ProfileDetails profile={profile} />}
        {activeTab === "address" && <AddressDetails profile={profile} />}
        {activeTab === "documentation" && <Documentation profile={profile} />}
        {activeTab === "social" && <SocialMedia profile={profile} />}
      </div>
    </>
  );
};

export default ProfileBanner;
